import {Affix, Button, Dropdown, Flex, Tooltip} from "antd";
import {SettingItem} from "./items/SettingItem";
import {CategoryItem} from "./items/CategoryItem";
import {ComponentItem} from "./items/ComponentItem";
import React, {useEffect, useRef, useState} from "react";
import {epochSetting} from "../../../setting/EpochSetting";
import {natureSetting} from "../../../setting/NatureSetting";
import {geographySetting} from "../../../setting/GeographySetting";
import {technologySetting} from "../../../setting/TechnologySetting";
import {magicSetting} from "../../../setting/MagicSetting";
import {anomalySetting} from "../../../setting/AnomalySetting";
import {cultureSetting} from "../../../setting/CultureSetting";
import {economicSetting} from "../../../setting/EconomicSetting";
import {politicsSetting} from "../../../setting/PoliticsSetting";
import {socialSetting} from "../../../setting/SocialSetting";
import {militarySetting} from "../../../setting/MIlitarySetting";
import {locationsSetting} from "../../../setting/LocationsSetting";
import {populationSetting} from "../../../setting/PopulationSetting";
import {organizationsSetting} from "../../../setting/OrganizationsSetting";
import {ElementItem} from "./items/ElementItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Setting} from "../../../setting/Setting";
import {extractSettingCategoriesPrompt} from "../prompts/SettingPrompts";
import {charactersSetting} from "../../../setting/CharactersSetting";
import {LoreItem} from "./items/LoreItem";
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../../../../../feature/tools";
import {
    DraftComponent,
    DraftComponentCategory,
    DraftElement, embeddedCategories, embeddedComponents, embeddedElements,
    fullfilledCategories, fullfilledComponents, fullfilledElements
} from "../../../../../../../feature/Draft";
import {addSettingCategory} from "../../../../../../../feature/project/draftSlice";
import {GenButton} from "../../../../../../../ai/components/GenButton";
import {aiChainPrompt} from "../../../../../../../ai/Prompt";

export const SettingList = (props: {
    selectedItem?: any,
    onItemSelected?: (data: any, category: DraftComponentCategory | undefined, component: DraftComponent | undefined, element: DraftElement | undefined) => void,
    expandedKeys: string[],
    onItemExpanded: (keys: string) => void
}) => {
    const draft = useAppSelector(state => state.draftSlice.draft)
    const dispatch = useAppDispatch()
    const [selectedCategory, setSelectedCategory] = useState<DraftComponentCategory | undefined>(undefined)
    const [selectedComponent, setSelectedComponent] = useState<DraftComponent | undefined>(undefined)
    const [selectedElement, setSelectedElement] = useState<DraftElement | undefined>(undefined)
    const {projectId} = useParams()
    const model = useAppSelector(state => state.draftSlice.model)
    const aiProviders = useAppSelector(state => state.aiSlice.projectAiProviderSettings)

    return (
        <Flex style={{flexGrow: 1, overflowY: 'auto'}} vertical={true} gap={10}>
            <Flex vertical={true} gap={10}>
                <SettingItem
                    setting={draft.setting}
                    active={props.selectedItem?.data && props.selectedItem.type == 'setting'}
                    fullFilled={fullfilledCategories(draft.setting.categories ?? [])}
                    showEmbeddingState={aiProviders.map(p => p.name).includes('OpenAI')}
                    expanded={props.expandedKeys.includes('setting')}
                    embedded={embeddedCategories(draft.setting.categories ?? [])}
                    onExpand={(setting) => {
                        props.onItemExpanded('setting')
                    }}
                    onSelected={(setting) => {
                        props.onItemSelected?.({data: setting, type: 'setting'}, undefined, undefined, undefined)
                        setSelectedCategory(undefined)
                        setSelectedComponent(undefined)
                    }}
                >
                    {draft.setting.categories?.map((category) => {
                            let categoryActive = selectedCategory?.category == category.category
                            const embedded = embeddedComponents(category)
                            let categoryKey = `category-${category.category}`
                            return <CategoryItem
                                key={category.id}
                                category={category}
                                active={categoryActive}
                                showEmbeddingState={aiProviders.map(p => p.name).includes('OpenAI')}
                                fullFilled={fullfilledComponents(category.components)}
                                expanded={props.expandedKeys.includes(`category-${category.category}`)}
                                embedded={embedded}
                                onExpand={(key) => {
                                    props.onItemExpanded(categoryKey)
                                }}
                                onCategorySelected={(category) => {
                                    props.onItemSelected?.({data: category, type: 'category'}, category, undefined, undefined)
                                    setSelectedCategory(category)
                                }}
                            >
                                {category.components.map((component: DraftComponent) => {
                                        const componentKey = `${categoryKey}-component-${component.id}`
                                        const componentActive = component.id == selectedComponent?.id && categoryActive
                                        return <ComponentItem
                                            key={componentKey}
                                            component={component}
                                            showEmbeddingState={aiProviders.map(p => p.name).includes('OpenAI')}
                                            active={componentActive}
                                            onComponentSelected={(component) => {
                                                props.onItemSelected?.({
                                                    data: component,
                                                    type: 'component'
                                                }, category, component, undefined)
                                                setSelectedComponent(component)
                                                setSelectedCategory(category)
                                            }}
                                            embedded={embeddedElements(component.elements)}
                                            fullFilled={fullfilledElements(component.elements)}
                                            onExpand={(key) => {
                                                props.onItemExpanded(componentKey)
                                            }}
                                            expanded={props.expandedKeys.includes(componentKey)}
                                        >
                                            {component.elements?.map((element) => {
                                                const elementKey = `${componentKey}-element-${element.id}`
                                                const elementActive = props.selectedItem?.data && props.selectedItem.type == "element" && props.selectedItem.data.id == element.id && componentActive
                                                return <ElementItem
                                                    key={elementKey}
                                                    element={element}
                                                    active={elementActive}
                                                    showEmbeddingState={aiProviders.map(p => p.name).includes('OpenAI')}
                                                    onElementSelected={(element) => {
                                                        props.onItemSelected?.({
                                                            data: element,
                                                            type: 'element'
                                                        }, category, component, element)
                                                        setSelectedComponent(component)
                                                        setSelectedCategory(category)
                                                    }}
                                                    expanded={props.expandedKeys.includes(elementKey)}
                                                    onExpand={(key) => {
                                                        props.onItemExpanded(elementKey)
                                                    }}
                                                >
                                                    {
                                                        element.items?.map((item) => {
                                                            const itemActive = props.selectedItem?.data && props.selectedItem.type == "item" && props.selectedItem.data.id == item.id && elementActive
                                                            return <LoreItem
                                                                key={`${elementKey}-item-${item.id}`}
                                                                item={item}
                                                                active={itemActive}
                                                                showEmbeddingState={aiProviders.map(p => p.name).includes('OpenAI')}
                                                                onElementSelected={(item) => {
                                                                    props.onItemSelected?.({
                                                                        data: item,
                                                                        type: 'item'
                                                                    }, category, component, element)
                                                                    setSelectedComponent(component)
                                                                    setSelectedCategory(category)
                                                                    setSelectedElement(element)
                                                                }}
                                                            />
                                                        })
                                                    }
                                                </ElementItem>
                                            })}
                                        </ComponentItem>
                                    }
                                )}
                            </CategoryItem>
                        }
                    )}
                    {!draft.setting.categories || draft.setting.categories?.length < categories.filter(c => c.key != 'History').length ?
                        <Flex style={{width: "100%"}} gap={10} justify={'stretch'}>
                            <Dropdown
                                trigger={['click']}
                                menu={
                                    {
                                        items:
                                            categories.filter(c => c.key != 'History' && !draft.setting.categories?.map(c => c.category).includes(c.key)).map((category) => (
                                                {
                                                    label: <Tooltip placement={'rightTop'} title={category.description}>
                                                        <div style={{width: '100%'}}>{category.title}</div>
                                                    </Tooltip>,
                                                    key: category.key,
                                                }
                                            ))
                                        , onClick: (item) => {
                                            const category = categories.find(c => c.key == item.key)
                                            const maxCategoryId = draft.setting.categories?.map(c => c.id).reduce((a, b) => Math.max(a, b), 0)
                                            if (category) {
                                                dispatch(
                                                    addSettingCategory(
                                                        {
                                                            category: {
                                                                id: maxCategoryId + 1,
                                                                category: category.key,
                                                                title: category.title,
                                                                description: combineSettingDescription(category),
                                                                components: []
                                                            }
                                                        }
                                                    )
                                                )
                                            }
                                        }
                                    }
                                }>


                                <Button
                                    style={{
                                        height: "auto",
                                        padding: '8px 8px 8px 16px',
                                        flexGrow: 1,
                                    }} icon={<FontAwesomeIcon icon={faPlus}/>}>Add Category</Button>

                            </Dropdown>
                            <GenButton
                                style={{
                                    height: "auto",

                                }}
                                mode={'icon'}
                                hideMainAction={false}
                                actions={[
                                    {
                                        key: '1',
                                        title: 'Fill Automatically',
                                        action: async (item) => {
                                            const data = await aiChainPrompt({
                                                projectId: projectId ?? "",
                                                prompt: extractSettingCategoriesPrompt(
                                                    {
                                                        synopsis: draft.properties.synopsis,
                                                        genres: draft.properties.genre,
                                                        setting: draft.setting.description ?? '',
                                                        categories: categories.filter(c => c.key != 'History').map(c => c.title),
                                                    }
                                                ),
                                                model: model,
                                                type: 'json'
                                            })
                                            const maxCategoryId = draft.setting.categories?.map(c => c.id).reduce((a, b) => Math.max(a, b), 0)
                                            let ind = 0
                                            data.data.forEach((d: string) => {
                                                const category = categories.find(c => c.title.toLowerCase() == d.toLowerCase())
                                                if (category) {
                                                    const categoryExists = draft.setting.categories?.find(c => c.category == category?.key)
                                                    if (!categoryExists) {
                                                        ind++
                                                        dispatch(
                                                            addSettingCategory(
                                                                {
                                                                    category: {
                                                                        id: maxCategoryId + ind,
                                                                        category: category.key,
                                                                        title: category?.title ?? '',
                                                                        description: combineSettingDescription(category),
                                                                        components: []
                                                                    }
                                                                }
                                                            )
                                                        )
                                                    }
                                                }
                                            })
                                        },
                                    }
                                ]}/> </Flex> : ''}

                </SettingItem>
            </Flex>
        </Flex>
    )
}

export const categories: Setting[] = [
    epochSetting,
    natureSetting,
    geographySetting,
    technologySetting,
    magicSetting,
    anomalySetting,
    cultureSetting,
    economicSetting,
    politicsSetting,
    socialSetting,
    militarySetting,
    locationsSetting,
    populationSetting,
    organizationsSetting,
    charactersSetting
]

export const combineSettingDescription = (setting?: Setting): string => {
    if (!setting) return ''
    return setting.description + `\n
Основные компоненты сеттинга ${setting.title} включают в себя:
${setting.components.map((component, index) => {
        return `\n${index + 1}. ${component.title}\n${component.subComponents.map((sc) => {
            return `\t- ${sc.title}\n\t  (например: ${sc.examples.join('; ')})`
        }).join('\n')}`
    }).join('\n')}`
}